import type { Messages } from './i18n/ru.ts';

const DAY = 86_400_000;

/**
 * The balance card's "monthly spend" and "lasts until": nothing when nothing renews, the date coloured by
 * how soon it is (red under 3 days, amber under a week).
 */
export function runwayProps(
  summary: { monthlyCents: number; runwayUntil: string | null },
  f: { money: (cents: number) => string; date: (iso: string) => string; t: Messages },
): { monthly?: string; runway?: string; runwayTone?: 'ok' | 'warn' | 'crit' } {
  if (summary.monthlyCents <= 0 && !summary.runwayUntil) return {};
  const monthly = summary.monthlyCents > 0 ? f.money(summary.monthlyCents) : undefined;
  if (!summary.runwayUntil) return { monthly, runway: f.t.balance.runwayYear, runwayTone: 'ok' };
  const left = new Date(summary.runwayUntil).getTime() - Date.now();
  return {
    monthly,
    runway: f.t.balance.runwayUntil(f.date(summary.runwayUntil)),
    runwayTone: left < 3 * DAY ? 'crit' : left < 7 * DAY ? 'warn' : 'ok',
  };
}
